import React from 'react'

// Métrique épurée pour la Timeline - Design minimaliste différent de NavigationItem
// Props: icon (React component), value (string|number), label (string), type (string), onClick (function)
export default function TimelineMetric({ icon: Icon, value, label, type, onClick, className = '', noBorder = false }) {
  const getIconStyle = () => {
    // Approche monochromatique élégante - sans gradients
    switch (type) {
      case 'owners':
        return 'text-blue-600'
      case 'properties':
        return 'text-emerald-600'
      case 'units':
        return 'text-purple-600'
      case 'occupancy':
        return 'text-amber-600'
      case 'arrears':
        return 'text-orange-600'
      case 'late':
        return 'text-red-600'
      default:
        return 'text-neutral-600'
    }
  }

  return (
    <div
      className={`group flex items-center gap-4 py-8 px-6 w-full ${noBorder ? '' : 'border-r border-neutral-100'} transition-all duration-300 ease-out ${
        onClick ? 'cursor-pointer hover:bg-neutral-50/50' : ''
      } ${className}`}
      onClick={onClick}
    >
      {/* Icône à gauche, accent discrèt */}
      <div className={`flex-shrink-0 transition-transform duration-300 ${onClick ? 'group-hover:scale-110' : ''}`}>
        {Icon ? (
          <Icon
            size={20}
            className={`${getIconStyle()} transition-colors duration-300`}
          />
        ) : null}
      </div>

      {/* Contenu principal - minimaliste */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <div className="text-3xl font-light text-neutral-900 tracking-tight leading-none">
          {isNaN(value) ? 0 : value}
        </div>
        <div className="text-xs font-medium text-neutral-500 uppercase tracking-wide">
          {label}
        </div>
      </div>
    </div>
  )
}


